module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qurin4-cca2167bc36ef01d8da9b5c8fd7d3898.jpg";